module.exports = __webpack_public_path__ + "static/media/020.8a7b46b8.jpg";